<!--
  +---------------------------------------------------------------------------------------
  | @Copyright: Frippler Copyright (c)
  | @Title:    增值-优惠券方案
  +---------------------------------------------------------------------------------------
-->

<template>
  <div class="ei-coupon padding-footer">
    <div class="filter-container">
      <div class="filter-box">
        <div class="filter-item">
          <f-radio-btn-group v-model="query.receive_status" :groups="status" @change="fetchData(1)" />
        </div>
        <div class="filter-item">
          <el-select v-model="query.coupon_type" placeholder="券类型" filterable clearable style="width: 120px;" @change="fetchData(1)">
            <el-option
              v-for="item in type"
              :key="item.value"
              :label="item.title"
              :value="item.value" />
          </el-select>
        </div>
      </div>

      <div class="toolbox">
        <el-button icon="el-icon-plus" type="success" @click="couponCreate">新建券方案</el-button>
      </div>
    </div>

    <el-card v-loading="loading" shadow="never">
      <el-table ref="listTable" :data="list" tooltip-effect="dark" class="padding-small">
        <el-table-column label="#" type="index" width="50" />
        <el-table-column :show-overflow-tooltip="true" label="券类型&面额" min-width="160">
          <template slot-scope="scope">
            <div>{{ scope.row.coupon_type == 1 ? '满减券' : scope.row.coupon_type == 2 ? '折扣券' : '新用户券' }}</div>
            <div>{{ scope.row.name }}</div>
          </template>
        </el-table-column>
        <el-table-column :show-overflow-tooltip="true" min-width="120" label="使用数/领取数">
          <template slot-scope="scope">
            <span>{{ scope.row.used_num + ' / ' + scope.row.receive_num }}</span>
          </template>
        </el-table-column>
        <el-table-column :show-overflow-tooltip="true" label="状态" min-width="120">
          <template slot-scope="scope">
            <div v-if="scope.row.receive_status != 3" class="flex align-items-center">
              <div class="mr-sm" :class="scope.row.receive_status == 1 ? 'text-warning' : 'text-primary'">{{ scope.row.receive_status == 1 ? '未生效' : '已生效' }}</div>
              <el-switch v-model="scope.row.receive_enable" :active-value="2" :inactive-value="1" @change="enableChange(scope.row)" />
            </div>
            <div v-else class="text-muted">已失效</div>
          </template>
        </el-table-column>

        <el-table-column :show-overflow-tooltip="true" min-width="120" label="券有效期">
          <template slot-scope="scope">
            <span>{{ '领取后' + scope.row.valid_days + '天内有效' }}</span>
          </template>
        </el-table-column>

        <el-table-column :show-overflow-tooltip="true" min-width="120" label="使用范围">
          <template slot-scope="scope">
            <span>{{ scope.row.use_range }}</span>
          </template>
        </el-table-column>
        <el-table-column label="创建时间" min-width="140">
          <template slot-scope="scope">
            <span>{{ scope.row.createtime | parseTime('{y}/{m}/{d} {h}:{i}') }}</span>
          </template>
        </el-table-column>

        <el-table-column width="100" label="操作">
          <template slot-scope="scope">
            <el-button type="text" @click="$router.push('/ei/coupon/detail?coupon_schemeid=' + scope.row.coupon_schemeid)">详情</el-button>
            <el-button v-if="scope.row.receive_status != 3" type="text" @click="abolishCoupon(scope.row)">作废</el-button>
            <el-button v-if="scope.row.receive_status == 3 " type="text" @click="delCoupon(scope.row)">删除</el-button>
          </template>
        </el-table-column>
        <template slot="append">
          <f-table-footer>
            <template slot="right">
              <f-pagination :total="total" :pindex.sync="query.pindex" :psize.sync="query.psize" @change="fetchData" />
            </template>
          </f-table-footer>
        </template>
        <div slot="empty" class="flex-center column pb-md">
          <div class="flex-center mt-hg">
            <img src="../../assets/no-data.png" alt="" class="no-data">
          </div>
        </div>
      </el-table>
    </el-card>

  </div>
</template>

<script>
import { couponListApi, couponEnableApi, couponAbolishApi, couponDeleteApi } from "@/api/ei/eiCouponApi"

export default {
  name: "EiCoupon",

  data() {
    return {
      loading: false,
      query: {
        pindex: 1,
        psize: this.$store.state.commonStore.psize,
        receive_status: null,
        coupon_type: null,
      },
      total: 0,
      list: [],
      status: [
        { value: null, title: '全部', separate: true },
        { value: 1, title: '未生效' },
        { value: 2, title: '生效中' },
        { value: 3, title: '已失效' },
      ],
      type: [
        { value: 1, title: '满减券' },
        { value: 3, title: '新用户券' },
      ]
    };
  },

  computed: {
    superFastLogin() {
      return this.$store.state.userStore.superFastLogin;
    },

    aiot_version() {
      return this.$store.state.godStore.aiot_version;
    },
  },

  created() {
    const keepAlivePath = ["/ei/coupon/detail"]
    this.query = this.$utils.initListQuery(this.query, keepAlivePath)
    this.fetchData(1)
  },

  beforeRouteLeave(to, from, next) {
    this.$utils.saveListQuery(this.query)
    next()
  },

  watch: {
  },

  methods: {
    couponCreate() {
      if (!this.superFastLogin && this.aiot_version == 2) {
        this.$alert('合作版暂不支持该操作！', '提示', {
          type: 'warning'
        })
        return
      }
      this.$router.push('/ei/coupon/create')
    },

    fetchData(page) {
      if (page) this.query.pindex = page
      this.loading = true
      couponListApi(this.query).then((res) => {
        this.loading = false
        if (!res.errno) {
          this.list = res.data.list
          this.total = res.data.total
        } else {
          this.$message.error(res.message)
        }
      })
    },

    enableChange(row) {
      if (!this.superFastLogin && this.aiot_version == 2) {
        row.receive_enable = row.receive_enable == 2 ? 1 : 2
        this.$alert('合作版暂不支持该操作！', '提示', {
          type: 'warning'
        })
        return
      }
      this.$confirm(row.receive_enable == 2 ? `此操作将开启 <span class="text-primary">${row.name}</span> 优惠券方案，是否继续？` : `此操作将关闭 <span class="text-primary">${row.name}</span> 优惠券方案，但已领取的优惠券仍能使用，是否继续？`, '提示', {
        dangerouslyUseHTMLString: true,
        type: 'warning'
      }).then(() => {
        this.loading = true
        couponEnableApi({ coupon_schemeid: row.coupon_schemeid, receive_enable: row.receive_enable }).then(res => {
          this.loading = false
          if (!res.errno) {
            this.fetchData()
            this.$message.success('操作成功')
          } else {
            row.receive_enable = row.receive_enable == 2 ? 1 : 2
            this.$message.error(res.message)
          }
        })
      }).catch(() => {
        row.receive_enable = row.receive_enable == 2 ? 1 : 2
      })
    },

    abolishCoupon(row) {
      if (!this.superFastLogin && this.aiot_version == 2) {
        this.$alert('合作版暂不支持该操作！', '提示', {
          type: 'warning'
        })
        return
      }
      this.$confirm(`此操作将作废 <span class="text-primary">${row.name}</span> 优惠券方案，已领取但未使用的优惠券将被作废，是否继续？`, '提示', {
        dangerouslyUseHTMLString: true,
        type: 'warning'
      }).then(() => {
        this.loading = true
        couponAbolishApi({ coupon_schemeid: row.coupon_schemeid }).then(res => {
          this.loading = false
          if (!res.errno) {
            this.fetchData()
            this.$message.success('作废成功')
          } else {
            this.$message.error(res.message)
          }
        })
      }).catch(() => {
      })
    },

    delCoupon(row) {
      if (!this.superFastLogin && this.aiot_version == 2) {
        this.$alert('合作版暂不支持该操作！', '提示', {
          type: 'warning'
        })
        return
      }
      this.$confirm(`此操作将删除 <span class="text-primary">${row.name}</span> 优惠券方案，是否继续？`, '提示', {
        dangerouslyUseHTMLString: true,
        type: 'warning'
      }).then(() => {
        this.loading = true
        couponDeleteApi({ coupon_schemeid: row.coupon_schemeid }).then(res => {
          this.loading = false
          if (!res.errno) {
            if(this.total % this.query.psize == 1 && this.query.pindex > 1) {
              this.query.pindex--
            }
            this.fetchData()
            this.$message.success('删除成功')
          } else {
            this.$message.error(res.message)
          }
        })
      }).catch(() => {
      })
    },
  },
};
</script>

<style lang="scss" scoped>
</style>